// import React, { useEffect, useState } from "react";
// import { Modal, Button, Form, OverlayTrigger, Tooltip } from "react-bootstrap";
// import Creatable from "react-select/creatable";
// import { API_BASE_URL, Assets_URL } from "../../../Apicongfig";
// import axios from "axios";

// const QuickMomentForm = ({ show, onClose }) => {
//   const [step, setStep] = useState(1);
//   const [selectedClient, setSelectedClient] = useState("");
//   const [newClient, setNewClient] = useState("");
//   const [selectedMission, setSelectedMission] = useState("");
//   const [newMission, setNewMission] = useState("");
//   const [momentType, setMomentType] = useState("");
//   const [momentName, setMomentName] = useState("");
//   const [showStepPopup, setShowStepPopup] = useState(false);

//   const solutions = ["Solution A", "Solution B"];
//   const customMomentTypes = ["From Scratch", "Planning", "Meeting"];

//   const isSolution = solutions.includes(momentType);
//   const isCustom = !isSolution && momentType !== "";

//   const handleContinue = () => setStep((prev) => prev + 1);

//   const [client, setClient] = useState(null); // value (id or name)
//   const [clientId, setClientId] = useState(null); // value (id or name)
//   const [mission, setMission] = useState(null); // value (id or name)
//   const [missionId, setMissionId] = useState(null); // value (id or name)

//   const handleValider = () => {
//     console.log("Creating solution moment:", { momentType, momentName });
//     // You can redirect or show the moment detail screen
//     onClose(); // close the modal after creation
//   };

//   const handleCustomMoment = () => {
//     setShowStepPopup(true);
//   };

//   const [usersArray, setUsersArray] = useState([]);

//   useEffect(() => {
//     // Fetch users to populate the select field
//     const fetchUsers = async () => {
//       try {
//         const response = await axios.get(
//           `${API_BASE_URL}/get-same-enterprise-users/${sessionStorage.getItem(
//             "user_id"
//           )}`,
//           {
//             headers: {
//               Authorization: `Bearer ${sessionStorage.getItem("token")}`,
//             },
//           }
//         );
//         if (response.status) {
//           setUsersArray(response.data?.data);
//         }
//       } catch (error) {
//         console.log("error fetching users", error);
//       }
//     };
//     fetchUsers();
//   }, []);

//   // const options = usersArray?.map((user) => ({
//   //   value: user.id,
//   //   label: user.name,
//   // }));
//   const options = usersArray?.map((user) => ({
//     value: user.id,
//     label: user.name,
//     data: {
//       // Add client_logo in a data object
//       client_logo: user.client_logo, // Make sure this matches your data structure
//     },
//   }));

//   const [missionOptions, setMissionOptions] = useState([]);

//   //   ----------------Missions------
//   const getObjectives = async () => {
//     try {
//       const userId = parseInt(sessionStorage.getItem("user_id"));
//       const response = await axios.get(
//         `${API_BASE_URL}/get-objectives/${userId}`,
//         {
//           headers: {
//             Authorization: `Bearer ${sessionStorage.getItem("token")}`,
//           },
//         }
//       );
//       if (response.status) {
//         const objectives = response?.data?.data;
//         const newOptions = objectives.map((item) => ({
//           value: item,
//           label: item,
//         }));
//         setMissionOptions(newOptions);
//       }
//     } catch (error) {}
//   };
//   useEffect(() => {
//     getObjectives();
//   }, []);

//     const objectives = missionOptions.map((item) => ({
//     value: item.value,
//     label: item.label,
//   }));
//   const renderStepContent = () => {
//     switch (step) {
//       case 1:
//         return (
//           <>
//             <div className="name" style={{ position: "relative", zIndex: 3 }}>
//               <label htmlFor="" className="form-label">
//                 Client
//                 <small
//                   style={{
//                     color: "red",
//                     fontSize: "15px",
//                     marginLeft: "2px",
//                   }}
//                 >
//                   *
//                 </small>
//               </label>
//               <OverlayTrigger
//                 placement="top"
//                 overlay={
//                   <Tooltip id="client-tooltip">
//                     💡 Commencez à taper pour rechercher un client existant ou
//                     en créer un nouveau automatiquement.
//                   </Tooltip>
//                 }
//               >
//                 <div>
//                   <Creatable
//                     className="my-select destination-select-dropdown"
//                     classNamePrefix="select"
//                     onChange={(option, actionMeta) => {
//                       if (option) {
//                         if (actionMeta.action === "create-option") {
//                           setClient(option.label);
//                           setClientId(null);
//                         } else {
//                           setClient(option.label);
//                           setClientId(option.value);
//                         }
//                       } else {
//                         setClient(null);
//                         setClientId(null);
//                       }
//                     }}
//                     value={
//                       clientId
//                         ? options.find(
//                             (opt) => Number(opt.value) === Number(clientId)
//                           )
//                         : client
//                         ? { label: client, value: client }
//                         : null
//                     }
//                     options={options}
//                     isClearable
//                     formatOptionLabel={(option, { context }) => (
//                       <div style={{ display: "flex", alignItems: "center" }}>
//                         {/* Show client logo if available */}
//                         {option.data?.client_logo && (
//                           <img
//                             src={
//                               option.data.client_logo.startsWith("http")
//                                 ? option.data.client_logo
//                                 : `${Assets_URL}/${option.data.client_logo}`
//                             }
//                             alt={option.label}
//                             style={{
//                               width: "24px",
//                               height: "24px",
//                               borderRadius: "50%",
//                               objectFit: "cover",
//                               marginRight: "10px",
//                             }}
//                           />
//                         )}
//                         {/* Client name */}
//                         <span>{option.label}</span>
//                       </div>
//                     )}
//                   />
//                 </div>
//               </OverlayTrigger>
//             </div>

//             <div className="d-flex justify-content-end mt-4">
//               <Button variant="primary" onClick={handleContinue}>
//                 Continue
//               </Button>
//             </div>
//           </>
//         );
//       case 2:
//         return (
//           <>
//             <div className="name" style={{ position: "relative", zIndex: 3 }}>
//               <label htmlFor="" className="form-label">
//                 Mission
//                 <small
//                   style={{
//                     color: "red",
//                     fontSize: "15px",
//                     marginLeft: "2px",
//                   }}
//                 >
//                   *
//                 </small>
//               </label>

//                 <div>
//                   <Creatable
//                     className="my-select destination-select-dropdown"
//                     classNamePrefix="select"
//                     onChange={(option, actionMeta) => {
//                       if (option) {
//                         if (actionMeta.action === "create-option") {
//                           setMission(option.label);
//                           setMissionId(null);
//                         } else {
//                           setMission(option.label);
//                           setMissionId(option.value);
//                         }
//                       } else {
//                         setMission(null);
//                         setMissionId(null);
//                       }
//                     }}
//                     value={
//                       missionId
//                         ? objectives.find(
//                             (opt) => Number(opt.value) === Number(clientId)
//                           )
//                         : mission
//                         ? { label: mission, value: mission }
//                         : null
//                     }
//                     options={objectives}
//                     isClearable
//                     formatOptionLabel={(option, { context }) => (
//                       <div style={{ display: "flex", alignItems: "center" }}>

//                         {/* Mission name */}
//                         <span>{option.label}</span>
//                       </div>
//                     )}
//                   />
//                 </div>
//             </div>

//             <div className="d-flex justify-content-end mt-4">
//               <Button variant="primary" onClick={handleContinue}>
//                 Continue
//               </Button>
//             </div>
//           </>
//         );
//       case 3:
//         return (
//           <>
//             <Form.Group className="mb-3">
//               <Form.Label>Moment Type</Form.Label>
//               <Form.Select
//                 value={momentType}
//                 onChange={(e) => setMomentType(e.target.value)}
//               >
//                 <option value="">-- Select Type --</option>
//                 {[...solutions, ...customMomentTypes].map((type) => (
//                   <option key={type} value={type}>
//                     {type}
//                   </option>
//                 ))}
//               </Form.Select>
//             </Form.Group>

//             <Form.Group className="mb-3">
//               <Form.Label>Moment Name</Form.Label>
//               <Form.Control
//                 type="text"
//                 placeholder="Enter moment name"
//                 value={momentName}
//                 onChange={(e) => setMomentName(e.target.value)}
//               />
//             </Form.Group>

//             <div className="d-flex justify-content-end mt-4">
//               {isSolution ? (
//                 <Button variant="primary" onClick={handleValider}>
//                   Valider
//                 </Button>
//               ) : (
//                 <Button variant="primary" onClick={handleCustomMoment}>
//                   Continuer
//                 </Button>
//               )}
//             </div>
//           </>
//         );
//       default:
//         return null;
//     }
//   };

//   return (
//     <>
//       <Modal show={show} onHide={onClose} size="lg" centered backdrop="static">
//         <Modal.Header closeButton>
//           <Modal.Title className="fw-bold">Create New Moment</Modal.Title>
//         </Modal.Header>
//         <Modal.Body>{renderStepContent()}</Modal.Body>
//       </Modal>

//       {/* Step Popup Modal (custom step creation) */}
//       <Modal
//         show={showStepPopup}
//         onHide={() => setShowStepPopup(false)}
//         size="lg"
//         centered
//       >
//         <Modal.Header closeButton>
//           <Modal.Title>Create Step</Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           {/* Insert your custom Step creation component here */}
//           <p>Step popup content goes here...</p>
//           <Form.Check type="checkbox" label="Create another" className="mt-3" />
//         </Modal.Body>
//         <Modal.Footer>
//           <Button variant="secondary" onClick={() => setShowStepPopup(false)}>
//             Cancel
//           </Button>
//           <Button
//             variant="primary"
//             onClick={() => {
//               setShowStepPopup(false);
//               onClose(); // close main modal
//             }}
//           >
//             Valider
//           </Button>
//         </Modal.Footer>
//       </Modal>
//     </>
//   );
// };

// export default QuickMomentForm;
import React, { useEffect, useState } from "react";
import { RxCross2 } from "react-icons/rx";
import { Modal, Button, Tooltip, OverlayTrigger } from "react-bootstrap";
import Creatable from "react-select/creatable";
import { API_BASE_URL, Assets_URL } from "../../../Apicongfig";
import axios from "axios";
import { useTranslation } from "react-i18next";
import { getOptions, solutionTypeIcons } from "../../../Utils/MeetingFunctions";
import Select from "react-select";
import { format } from "date-fns";
import Flatpickr from "react-flatpickr";
import "flatpickr/dist/themes/material_blue.css";
import { French } from "flatpickr/dist/l10n/fr.js";
import { useDraftMeetings } from "../../../../context/DraftMeetingContext";
import QuickStepChart from "./QuickStepChart";
import moment from "moment";
import {
  formatDate,
  formatTime,
} from "../../Meeting/GetMeeting/Helpers/functionHelper";
import { useNavigate } from "react-router-dom";
import { MdOutlineSupport } from "react-icons/md";
import { IoIosBusiness, IoIosRocket } from "react-icons/io";
import { AiOutlineAudit } from "react-icons/ai";
import { FaBookOpen } from "react-icons/fa";
import Solution from "../../Meeting/CreateNewMeeting/components/Template";
import { useFormContext } from "../../../../context/CreateMeetingContext";
import { toast } from "react-toastify";
import { useHeaderTitle } from "../../../../context/HeaderTitleContext";

const QuickMomentForm = ({
  show,
  onClose,
  openedFrom,
  destination,
  refresh,
}) => {
  const [t] = useTranslation("global");
  const [step, setStep] = useState(openedFrom === "mission" ? 1 : 1);
  const [momentType, setMomentType] = useState("");
  const [momentName, setMomentName] = useState("");
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [showStepsModal, setShowStepsModal] = useState(false);
  const [stepsList, setStepsList] = useState([]);
  const [newStep, setNewStep] = useState("");
  const [isDrop, setIsDrop] = useState(false);
  const [meeting, setMeeting] = useState(null);
  const [id, setId] = useState(null);
const {  user} =
      useHeaderTitle();
  // Client and mission states
  const [client, setClient] = useState(null);
  const [clientId, setClientId] = useState(null);
  
  const [mission, setMission] = useState(null);
  const [missionId, setMissionId] = useState(null);
    const [selectedClient, setSelectedClient] = useState(null);
    const [selectedMission, setSelectedMission] = useState(null);
  
  const [destinationType, setDestinationType] = useState(null);
  const [usersArray, setUsersArray] = useState([]);
  const [missionOptions, setMissionOptions] = useState([]);
  const navigate = useNavigate();
    // Handle client selection
  const handleClientSelect = (selectedOption) => {
    setSelectedClient(selectedOption);
    setSelectedMission(null);
  };


    // Update mission selection handler to fetch moments
    const handleMissionSelect = (selectedOption) => {
      setSelectedMission(selectedOption);
  
      // if (selectedOption && selectedOption.value) {
      //   // fetchMoments(selectedOption.value);
      // }
    };
  

     const formatMissionOption = ({ label, status }) => {
    let statusColor = "#5b7aca";
    let localizedStatus = t("mission-badges.upcoming");

    if (status === "in_progress") {
      statusColor = "#f2db43";
      localizedStatus = t("mission-badges.inProgress");
    } else if (status === "closed") {
      statusColor = "rgba(47, 187, 103, 0.1019607843)";
      localizedStatus = t("mission-badges.completed");
    } else if (status === "active") {
      statusColor = "#5b7aca";
      localizedStatus = t("mission-badges.upcoming");
    } else if (status === "TODO") {
      statusColor = "#5b7aca";
      localizedStatus = t("mission-badges.new");
    } else {
      // Fallback for new options
      statusColor = "#ccc";
      localizedStatus = t("mission-badges.new"); // or 'Custom'
    }

    return (
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <span>{label}</span>
        <span
          style={{
            backgroundColor: statusColor,
            color: status === "closed" ? "#2fa25d" : "#fff",
            padding: "2px 8px",
            borderRadius: "8px",
            fontSize: "12px",
          }}
        >
          {localizedStatus}
        </span>
      </div>
    );
  };


   const getFilteredMissions = () => {
    if (!selectedClient) return []; // No client selected, show empty

    return missionOptions.filter(
      (mission) => mission.client_id === selectedClient.value
    );
  };
  const {
    checkId,
    setCheckId,
    deleteMeeting,
    saveDraft,
    open,
    handleCloseModal,
    isUpdated,
    isDuplicate,
    validateAndUpdate,
    addParticipant,
    changePrivacy,
    changeContext,
    changeOptions,
    // meeting,
    // setMeeting,
    setSelectedTab,
    setFormState,
    formState,
    handleInputBlur,
  } = useFormContext();

  useEffect(() => {
    if (destination || meeting) {
      setMissionId(destination?.id || meeting?.destination_id);
      setClientId(destination?.client_id || meeting?.destination?.client_id);
      setDestinationType(
        destination?.destination_type || meeting?.destination?.destination_type
      );
    }
  }, [destination, meeting]);
  // Fetch users on component mount
  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const response = await axios.get(
          `${API_BASE_URL}/get-same-enterprise-users/${sessionStorage.getItem(
            "user_id"
          )}`,
          {
            headers: {
              Authorization: `Bearer ${sessionStorage.getItem("token")}`,
            },
          }
        );
        if (response.status) {
            const clientsData = response.data.data;

        const userClients = clientsData
          .filter((client) => client.linked_to === "user")
          .map((client) => ({
            label: client.name,
            value: client.id,
            data: {
              client_logo: client.client_logo,
            },
          }));

        const enterpriseClients = clientsData
          .filter((client) => client.linked_to === "enterprise")
          .map((client) => ({
            label: client.name,
            value: client.id,
            data: {
              client_logo: client.client_logo,
            },
          }));

        setUsersArray([
          {
            label: "Mon entreprise",
            options: enterpriseClients,
          },
          {
            label: "Nos clients",
            options: userClients,
          },
        ]);
        const destinationClient ={
          label: destination?.clients?.name || "",
          value: destination?.clients?.id || "",
          data: {
            client_logo: destination?.clients?.client_logo || "",
          },
        }
         // Set the first enterprise client as default if exists
        if (enterpriseClients.length > 0 && openedFrom !== "mission") {
          setSelectedClient(enterpriseClients[0]);
        }else{
          setSelectedClient(destinationClient)
        }

        }
      } catch (error) {
        console.log("error fetching users", error);
      }
    };
    fetchUsers();
  }, []);
    
  const userProfile = user?.job || "Other / Explorer";

  // Fetch missions
  const getObjectives = async () => {
    try {
      const userId = parseInt(sessionStorage.getItem("user_id"));

      const response = await axios.get(
        `${API_BASE_URL}/get-objectives-with-id/${userId}`,
        {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("token")}`,
          },
        }
      );
      if (response.status) {
        const objectives = response?.data?.data;
        const newOptions = objectives.map((item) => ({
          value: item?.id,
          label: item?.name,
          client_id: item?.client_id,
          status: item?.status,

        }));
        setMissionOptions(newOptions);

         // Check if we should use an existing mission
      const existingMission = newOptions.find(option => 
        option.label.includes(selectedClient?.label)
      );
      
      if (existingMission) {
        setSelectedMission({
          ...existingMission,
          __isNew__: false
        });
      }

      }
    } catch (error) {
      console.log("error fetching objectives", error);
    }
  };

  useEffect(() => {
    getObjectives();
  }, []);

  // Set default values when step or client changes
useEffect(() => {
  if (!selectedClient?.label) return;

   // Determine default mission label based on user profile
  let defaultMissionLabel = `Projet ${selectedClient.label}`;
  let defaultMissionValue = null;
  let isNewMission = true;

  
  switch(userProfile) {
        case 'Project Manager / Product Owner':
          defaultMissionLabel = `Projet ${selectedClient?.label}`;;
          break;
        case 'Customer Relations Officer / Sales Representative':
          defaultMissionLabel = `Opportunité client ${selectedClient?.label}`;
          break;
        case 'Manager / Team Leader':
          defaultMissionLabel = `Projet ${selectedClient?.label}`;;
          break;
        case 'Developer / Operational Contributor':
          defaultMissionLabel = `Projet ${selectedClient?.label}`;;
          break;
        // Add other cases if needed
        default:
          defaultMissionLabel = `Projet ${selectedClient?.label}`;
      }

  // Check if mission exists (case-insensitive) and get its ID if exists
  const existingMission = missionOptions.find(option => 
    option.label.toLowerCase() === defaultMissionLabel.toLowerCase()
  );

  if (existingMission) {
    defaultMissionValue = existingMission.value;
    isNewMission = false;
  }

  const defaultDestinationType = 
    userProfile === "Customer Relations Officer / Sales Representative" 
      ? "Business opportunity" 
      : "Project";

  setSelectedMission({
    __isNew__: isNewMission,
    value: defaultMissionValue, // Will be null if new, or the existing ID if found
    label: defaultMissionLabel,
    client_id: selectedClient.value,
    status: 'upcoming',
    type: defaultDestinationType // Include type for payload consistency
  });

  setDestinationType(defaultDestinationType);
  setMomentName(`${t(`types.${formState?.type}`)} ${selectedClient.label}` || "");
}, [step, selectedClient, userProfile,missionOptions]);


  const getMeeting = async () => {
    const currentTime = new Date();
    const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

    const options = { timeZone: userTimeZone };
    const timeInUserZone = new Date(
      currentTime.toLocaleString("en-US", options)
    );

    const formattedTime = formatTime(timeInUserZone);
    const formattedDate = formatDate(timeInUserZone);
    const userId = parseInt(sessionStorage.getItem("user_id"));
    try {
      const response = await axios.get(
        `${API_BASE_URL}/get-meeting/${meeting?.id}?current_time=${formattedTime}&current_date=${formattedDate}&user_id=${userId}&timezone=${userTimeZone}`
      );
      if (response?.status === 200) {
        setMeeting(response?.data?.data);
      }
    } catch (error) {
      console.log("error", error);
    }
  };

  useEffect(() => {
    if (showStepsModal && meeting) {
      getMeeting();
    }
  }, [showStepsModal]);




  const objectives = missionOptions
    ?.filter((item) => item?.client_id == clientId)
    .map((item) => ({
      value: item.value,
      label: item.label,
    }));



  const handleCreate = async () => {
    const userTimezone = moment.tz.guess();
    const dateTime =
      selectedDateTime && selectedDateTime.length > 0
        ? selectedDateTime[0]
        : new Date();

    // Validation for step 1 (Solution tab)
    if (step === 1) {
      if (!formState.type && formState.solution_tab === "create from scratch") {
        toast.error(t("meeting.formState.type"));
        return;
      }
      if (
        !formState.solution_id &&
        formState.solution_tab === "use a template"
      ) {
        toast.error(t("meeting.formState.type"));
        return;
      }
    }

    let meetingData = {};
    let api_end_point = "/meetings";
    let method = "post";
 const isNewClient = selectedClient?.__isNew__;
      const isNewMission = selectedMission?.__isNew__;
    if (step === 1) {
      // Initial creation - Solution tab
      meetingData = {
        ...formState,
        status: "draft",
        timezone: userTimezone,
        date: dateTime.toISOString().split("T")[0],
        start_time: dateTime.toTimeString().split(" ")[0],
      };

      // When opened from mission, include client_id and destination_id immediately
      if (openedFrom === "mission") {
        meetingData = {
          ...meetingData,
          client_id: destination?.clients?.id || destination?.client_id,
          destination_id:  destination?.id || destination?.client_id,
          destination_type:  destination?.type || null,
          

        };
      }
    } else if (step === 2 && openedFrom !== "mission") {
      // Client tab - no API call, just proceed to next step (only for non-mission flow)
      setStep(3);
      return;
    } else if (
      (step === 3 && openedFrom !== "mission") ||
      (step === 2 && openedFrom === "mission")
    ) {
      // Mission tab update for normal flow OR moment tab for mission flow
      meetingData = {
        ...formState,
        client_id: !isNewClient ? selectedClient?.value : null,
          client: isNewClient ? selectedClient?.label : null,

          destination_id: !isNewMission ? selectedMission?.value : null,
          destination: isNewMission ? selectedMission?.label : null,
          destination_type: isNewMission ? destinationType : null,
        
        status: "draft", // Keep as draft until final submit
        timezone: userTimezone,
        _method: "put",
      };
      api_end_point = `/meetings/${meeting?.id}`;
    }

    try {
      const res = await axios.post(
        `${API_BASE_URL}${api_end_point}`,
        meetingData,
        {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("token")}`,
          },
        }
      );

      if (res.status === 201 || res.status === 200) {
        const data = res?.data?.data;
        setMeeting(data);
        setFormState(data);

        if (openedFrom === "mission") {
          // For mission flow, after step 1 go to step 2 (moment tab)
          if (step === 1) setStep(2);
        } else {
          // For normal flow
          if (step === 1) setStep(2);
          else if (step === 3) setStep(4);
        }
      }
    } catch (err) {
      console.error("Error in handleCreate:", err);
      toast.error(t("An error occurred while saving"));
    }
  };

  const handleFinalSubmit = async () => {
    const userTimezone = moment.tz.guess();
    const dateTime =
      selectedDateTime && selectedDateTime.length > 0
        ? selectedDateTime[0]
        : new Date();

    // Determine if we're using a template or creating from scratch
    const isTemplate =
      formState.solution_tab === "use a template" && formState.solution_id;
       const isNewClient = selectedClient?.__isNew__;
      const isNewMission = selectedMission?.__isNew__;

    const payload = {
      ...formState,
         client_id: !isNewClient ? selectedClient?.value : null,
          client: isNewClient ? selectedClient?.label : null,
 // Conditional fields based on new/existing mission
    ...(isNewMission 
      ? {
          destination: selectedMission.label,
          destination_type: destinationType,
        }
      : {
          destination_id: selectedMission.value,
          destination_type: selectedMission.type || destinationType,
        }
    ),
      title: momentName,
      date: dateTime.toISOString().split("T")[0],
      start_time: dateTime.toTimeString().split(" ")[0],
      timezone: userTimezone,
      status: "active",
      _method: "put",
    };

    try {
      const res = await axios.post(
        `${API_BASE_URL}/meetings/${meeting?.id}`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("token")}`,
          },
        }
      );

      if (res.status === 200 || res?.status === 201) {
        if (isTemplate) {
          // For templates, navigate to invite page
          navigate(`/invite/${meeting?.id}`);
              setMeeting(null);
      setFormState({
      selectedOption: null,
      title: "",
      date: "",
      start_time: "",
      description: "",
      type: "",
      priority: "",
      alarm: false,
      feedback: false,
      remainder: false,
      notification:false,
      autostart: false,
      playback: "Manual",
      prise_de_notes: "Manual",
      note_taker: false,
      objective: "",
      participants: [],
    steps:[],
        solution_tab: "use a template",
        solution_id:null,
      id: null,
      repetition: false,
      repetition_number: 1,
      repetition_frequency: "Daily",
      repetition_end_date: null,
      selected_days: [],
      teams: [],
      moment_privacy: "participant only",
      moment_privacy_teams: [],
      moment_password: null,
      location: null,
      agenda: null,
      address:null,
      room_details: null,
      phone: null,
      share_by: null,
      price: null,
                max_participants_register: 0,

      casting_tab: null,
    });
       
        } else {
          // For solutions, show steps modal
          setShowStepsModal(true);
        }
      }
    } catch (err) {
      console.error("Error finalizing meeting:", err);
      toast.error(t("An error occurred while finalizing the meeting"));
    }finally{
     
    }
  };

  // const handleContinue = async () => {
  //   const userTimezone = moment.tz.guess();

  //   if (step === 1) {
  //     if (isTemplateSelected) {
  //       // Only send template data to API, no modal
  //       const dateTime =
  //         selectedDateTime && selectedDateTime.length > 0
  //           ? selectedDateTime[0]
  //           : new Date();

  //       const payload = {
  //         solution_id: selectedTemplate?.id,
  //         type: null,
  //         title: momentName,
  //         client: clientId ? null : client,
  //         client_id: clientId || null,
  //         mission: missionId ? null : mission,
  //         mission_id: missionId || null,
  //         destination_type: destinationType,
  //         date: dateTime.toISOString().split("T")[0],
  //         start_time: dateTime.toTimeString().split(" ")[0],
  //         timezone: userTimezone,
  //       };

  //       try {
  //         const res = await axios.post(
  //           `${API_BASE_URL}/quick-planning`,
  //           payload,
  //           {
  //             headers: {
  //               Authorization: `Bearer ${sessionStorage.getItem("token")}`,
  //             },
  //           }
  //         );

  //         if (res.status === 201) {
  //           onClose(); // or handleSuccess()
  //           const data = res?.data?.data;
  //           navigate(`/invite/${data?.id}`);
  //         }
  //       } catch (err) {
  //         console.error("Error validating template:", err);
  //       }
  //     } else if (isSolutionSelected) {
  //       if (meeting?.id) {
  //         // If meeting already exists, just reopen step popup
  //         setShowStepsModal(true);
  //         return;
  //       }
  //       // Proceed to open step modal
  //       const dateTime =
  //         selectedDateTime && selectedDateTime.length > 0
  //           ? selectedDateTime[0]
  //           : new Date();

  //       const meetingData = {
  //         type: momentType?.value,
  //         solution_id: null,
  //         title: momentName,
  //         client: clientId ? null : client,
  //         client_id: clientId || null,
  //         mission: missionId ? null : mission,
  //         mission_id: missionId || null,
  //         destination_type: destinationType,
  //         date: dateTime.toISOString().split("T")[0],
  //         start_time: dateTime.toTimeString().split(" ")[0],
  //         timezone: userTimezone,
  //       };

  //       try {
  //         const res = await axios.post(
  //           `${API_BASE_URL}/meetings`,
  //           meetingData,
  //           {
  //             headers: {
  //               Authorization: `Bearer ${sessionStorage.getItem("token")}`,
  //             },
  //           }
  //         );

  //         if (res.status === 201) {
  //           // onClose(); // or handleSuccess()
  //           const data = res?.data?.data;
  //           console.log("data", data);
  //           // onClose(); // or handleSuccess()
  //           setMeeting(data);
  //           // setShowStepsModal(true);
  //         }
  //       } catch (err) {
  //         console.error("Error validating template:", err);
  //       }
  //       // setId(generateUniqueId());
  //     }
  //   } else {
  //     setStep((prev) => prev + 1);
  //   }
  // };

  // const createMeeting = async () => {
  //   onClose();
  //   navigate(`/invite/${meeting?.id}`);
  // };

  // const generateUniqueId = () => {
  //   return Date.now().toString(36) + Math.random().toString(36).substr(2);
  // };

  const handleBack = () => {
    if (openedFrom === "mission") {
      // No back navigation when opened from mission
      return;
    }
    setStep((prev) => prev - 1);
  };

  const handleValider = () => {
    console.log("Creating solution moment:", {
      momentType,
      momentName,
      steps: stepsList,
      client,
      mission,
    });
    onClose();
  };

  const handleCancel = () => setShowConfirmation(true);
  const handleCloseConfirmation = () => setShowConfirmation(false);


  const { language } = useDraftMeetings();
  let [locale, setLocale] = useState(null);
  if (language === "en") {
    locale = undefined;
  } else {
    locale = French;
  }
  const [selectedDateTime, setSelectedDateTime] = useState(new Date());
  const formatDateWithCustomTime = (date) => {
    return format(date, "dd/MM/yyyy, HH'h'mm");
  };

  const handleChange = (date) => {
    setSelectedDateTime(date);
    if (date) {
      const datePart = date[0]?.toISOString().split("T")[0];
      const timePart = date[0]?.toTimeString().split(" ")[0];
    }
  };

  // Options with labels
  const missionTypeOptions = [
    {
      value: "Business opportunity",
      label: t("destination.businessOppurtunity"),
    },
    { value: "Study", label: t("destination.study") },
    { value: "Audit", label: t("destination.audit") },
    { value: "Project", label: t("destination.project") },
    { value: "Accompagnement", label: t("destination.accompagnement") },
    { value: "Other", label: t("destination.other") },
  ];

  // Icon getter
  const getIcon = (option) => {
    switch (option.value) {
      case "Business opportunity":
        return (
          <IoIosBusiness
            style={{ width: 20, height: 20, marginRight: 8 }}
            color="#2c3e50"
          />
        );
      case "Study":
        return (
          <FaBookOpen
            style={{ width: 20, height: 20, marginRight: 8 }}
            color="#2c3e50"
          />
        );
      case "Audit":
        return (
          <AiOutlineAudit
            style={{ width: 20, height: 20, marginRight: 8 }}
            color="#2c3e50"
          />
        );
      case "Project":
        return (
          <IoIosRocket
            style={{ width: 20, height: 20, marginRight: 8 }}
            color="#2c3e50"
          />
        );
      case "Accompagnement":
        return (
          <MdOutlineSupport
            style={{ width: 20, height: 20, marginRight: 8 }}
            color="#2c3e50"
          />
        );
      case "Other":
        return <span style={{ marginRight: 8 }}>✨</span>;
      default:
        return null;
    }
  };

  const renderStepContent = () => {
    if (openedFrom === "mission") {
      // Only show Solution and Moment tabs when opened from mission
      switch (step) {
        case 1: // Solution tab
          return (
            <div className="step-content">
              <div className="form-group">
                <Solution from="quick" />
              </div>
            </div>
          );
        case 2: // Moment tab (renumbered from original step 4)
          return (
            <div className="create-moment-modal">
              <div className="step-content">
                <div className="d-flex flex-column gap-2 mb-4">
                 {(client || clientId) && (
  <div
    className="selected-summary mb-3 p-3"
    style={{
      backgroundColor: "#f5f7fa",
      borderRadius: "8px",
    }}
  >
    <strong>{t("Selected Client")}:</strong>{" "}
    {clientId
      ? (() => {
          // Search through all groups and options to find the matching client
          for (const group of usersArray) {
            const foundClient = group.options.find(
              (opt) => Number(opt.value) === Number(clientId)
            );
            if (foundClient) return foundClient.label;
          }
          return clientId; // fallback if not found
        })()
      : client}
  </div>
)}
                  {(mission || missionId) && (
                    <div
                      className="selected-summary mb-3 p-3"
                      style={{
                        backgroundColor: "#f5f7fa",
                        borderRadius: "8px",
                      }}
                    >
                      <strong>{t("Selected Mission")}:</strong>{" "}
                      {missionId
                        ? objectives.find(
                            (opt) => Number(opt.value) === Number(missionId)
                          )?.label
                        : mission}
                    </div>
                  )}
                </div>

                <div className="form-group">
                  <label className="form-label">
                    {t("Objective")}{" "}
                    <span className="required-asterisk">*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder={t("meeting.newMeeting.placeholders.objective")}
                    value={momentName}
                    onChange={(e) => setMomentName(e.target.value)}
                  />
                </div>

                <div className="mb-4 form d-flex flex-column form-group">
                  <label className="form-label">
                    {t("meeting.formState.dateTime")}
                    <small style={{ color: "red", fontSize: "15px" }}>*</small>
                  </label>
                  <Flatpickr
                    data-enable-time
                    value={selectedDateTime}
                    onChange={handleChange}
                    options={{
                      locale: locale,
                      dateFormat: "d/m/Y, H:i",
                      time_24hr: true,
                      formatDate: (date) => formatDateWithCustomTime(date),
                    }}
                  />
                </div>
              </div>
            </div>
          );
        default:
          return null;
      }
    }

    // Normal flow for other cases
  //   switch (step) {
  //     case 1:
  //       return (
  //         <div className="step-content">
  //           <div className="form-group">
  //             <Solution from="quick" />
  //           </div>
  //         </div>
  //       );
  //     case 2:
  //       return (
  //         <div className="step-content">
  //           <div className="form-group">
  //             <label className="form-label">
  //               {t("Client")}
  //               <span className="required-asterisk">*</span>
  //             </label>
  //             <OverlayTrigger
  //               placement="top"
  //               overlay={
  //                 <Tooltip id="client-tooltip">{t("clientTooltip")}</Tooltip>
  //               }
  //             >
  //               {meeting?.type === "Absence" ? (
  //                 // Readonly Select field for Absence type
  //                 <Select
  //                   classNamePrefix="select"
  //                   className="my-select destination-select-dropdown"
  //                   value={{
  //                     value: meeting?.destination?.clients?.id,
  //                     label:
  //                       meeting?.destination?.clients?.name ||
  //                       t("No client assigned"),
  //                     data: {
  //                       client_logo: meeting?.destination?.clients?.client_logo,
  //                       client_need_description:
  //                         meeting?.destination?.clients
  //                           ?.client_need_description,
  //                     },
  //                   }}
  //                   options={
  //                     meeting?.destination?.clients
  //                       ? [
  //                           {
  //                             value: meeting.destination.clients.id,
  //                             label: meeting.destination.clients.name,
  //                             data: {
  //                               client_logo:
  //                                 meeting.destination.clients.client_logo,
  //                               client_need_description:
  //                                 meeting.destination.clients
  //                                   .client_need_description,
  //                             },
  //                           },
  //                         ]
  //                       : []
  //                   }
  //                   isDisabled={true}
  //                   formatOptionLabel={(option) => (
  //                     <div className="option-with-logo">
  //                       {option.data?.client_logo && (
  //                         <img
  //                           src={
  //                             option.data.client_logo.startsWith("http")
  //                               ? option.data.client_logo
  //                               : `${Assets_URL}/${option.data.client_logo}`
  //                           }
  //                           alt={option.label}
  //                           className="client-logo"
  //                         />
  //                       )}
  //                       <span>{option.label}</span>
  //                     </div>
  //                   )}
  //                 />
  //               ) : (
  //                 <div>
  //                   <Creatable
  //                     className="my-select destination-select-dropdown"
  //                     classNamePrefix="select"
  //                     // isLoading={isClientsLoading}
  //                     options={usersArray}
  //                     onChange={handleClientSelect}
  //                     value={selectedClient}
  //                     placeholder={t("Select or create a client")}
  //                     formatOptionLabel={(option, { context }) => (
  //                       <div style={{ display: "flex", alignItems: "center" }}>
  //                         {/* Show client logo if available */}
  //                         {option.data?.client_logo && (
  //                           <img
  //                             src={
  //                               option.data.client_logo.startsWith("http")
  //                                 ? option.data.client_logo
  //                                 : `${Assets_URL}/${option.data.client_logo}`
  //                             }
  //                             alt={option.label}
  //                             style={{
  //                               width: "24px",
  //                               height: "24px",
  //                               borderRadius: "50%",
  //                               objectFit: "cover",
  //                               marginRight: "10px",
  //                             }}
  //                           />
  //                         )}
  //                         {/* Client name */}
  //                         <span>{option.label}</span>
  //                       </div>
  //                     )}
  //                     isClearable
  //                   />
  //                 </div>
  //               )}
  //             </OverlayTrigger>
  //           </div>
  //         </div>
  //       );
  //     case 3:
  //       return (
  //         <div className="step-content">
  //           {selectedClient && (
  //             <div
  //               className="selected-summary mb-3 p-3"
  //               style={{ backgroundColor: "#f5f7fa", borderRadius: "8px" }}
  //             >
  //               <strong>{t("Selected Client")}:</strong>{" "}
  //              {selectedClient?.value && !selectedClient?.__isNew__
  //                 ? (() => {
  //                     // Search through all client groups for the matching client
  //                     for (const group of usersArray) {
  //                       const foundClient = group.options.find(
  //                         (opt) =>
  //                           Number(opt.value) === Number(selectedClient?.value)
  //                       );
  //                       if (foundClient) return foundClient.label;
  //                     }
  //                     return selectedClient?.label;
  //                   })()
  //                 : selectedClient?.label}
  //             </div>
  //           )}

  //           <div className="form-group">
  //             <label className="form-label">
  //               {t("Mission")}
  //               <span className="required-asterisk">*</span>
  //             </label>
  //             {meeting?.type === "Absence" ? (
  //               // Readonly Select field for Absence type
  //               <Select
  //                 classNamePrefix="select"
  //                 className="my-select destination-select-dropdown mb-3"
  //                 value={{
  //                   value: meeting?.destination?.id,
  //                   label:
  //                     meeting?.destination?.destination_name ||
  //                     t("No mission assigned"),
  //                   data: {
  //                     description:
  //                       meeting?.destination?.destination_description,
  //                   },
  //                 }}
  //                 options={
  //                   meeting?.destination
  //                     ? [
  //                         {
  //                           value: meeting.destination.id,
  //                           label: meeting.destination.destination_name,
  //                           data: {
  //                             description:
  //                               meeting.destination.destination_description,
  //                           },
  //                         },
  //                       ]
  //                     : []
  //                 }
  //                 isDisabled={true}
  //               />
  //             ) : (
  //              <Creatable
  //                             className="my-select destination-select-dropdown"
  //                             classNamePrefix="select"
  //                             // isLoading={isMissionsLoading}
  //                             options={getFilteredMissions()} // Only show missions for selected client
  //                             onChange={handleMissionSelect}
  //                             value={selectedMission}
  //                             placeholder={t("Select a mission")}
  //                             isDisabled={!selectedClient}
  //                             isClearable
  //                             formatOptionLabel={formatMissionOption}
  //                           />
  //             )}
  //           </div>
  //            {selectedMission?.__isNew__ && (
  //                         <div className="form-group mt-3">
  //                           <label className="form-label">
  //                             {t("destination_type")}
  //                             <span className="required-asterisk">*</span>
  //                           </label>
  //                           <Select
  //                             className="my-select "
  //                             classNamePrefix="select"
  //                             styles={{
  //                               control: (provided, state) => ({
  //                                 ...provided,
  //                                 zIndex: 9, // Ensure dropdown is above other elements
  //                               }),
  //                             }}
  //                             options={missionTypeOptions}
  //                             value={missionTypeOptions.find(
  //                               (opt) => opt.value === destinationType
  //                             )}
  //                             onChange={(option) => setDestinationType(option.value)}
  //                             formatOptionLabel={(option) => (
  //                               <div style={{ display: "flex", alignItems: "center" }}>
  //                                 {getIcon(option)}
  //                                 <span>{option.label}</span>
  //                               </div>
  //                             )}
  //                             isClearable
  //                           />
  //                         </div>
  //                       )}
  //         </div>
  //       );
  //     case 4:
  //       return (
  //         <div className="create-moment-modal">
  //           <div className="step-content">
  //             <div className="d-flex flex-column gap-2 mb-4">
  //               {selectedClient && (
  //                 <div
  //                   className="selected-summary mb-3 p-3"
  //                   style={{ backgroundColor: "#f5f7fa", borderRadius: "8px" }}
  //                 >
  //                   <strong>{t("Selected Client")}:</strong>{" "}
  //                {selectedClient?.value && !selectedClient?.__isNew__
  //                 ? (() => {
  //                     // Search through all client groups for the matching client
  //                     for (const group of usersArray) {
  //                       const foundClient = group.options.find(
  //                         (opt) =>
  //                           Number(opt.value) === Number(selectedClient?.value)
  //                       );
  //                       if (foundClient) return foundClient.label;
  //                     }
  //                     return selectedClient?.label;
  //                   })()
  //                 : selectedClient?.label}
  //                 </div>
  //               )}

  //               {selectedMission && (
  //                 <div
  //                   className="selected-summary mb-3 p-3"
  //                   style={{ backgroundColor: "#f5f7fa", borderRadius: "8px" }}
  //                 >
  //                   <strong>{t("Selected Mission")}:</strong>{" "}
  // {selectedMission?.value && !selectedMission?.__isNew__
  //                 ? objectives.find(
  //                     (opt) =>
  //                       Number(opt.value) === Number(selectedMission?.value)
  //                   )?.label
  //                 : selectedMission?.label}
  //                 </div>
  //               )}
  //             </div>

  //             <div className="form-group">
  //               <label className="form-label">
  //                 {t("Objective")} <span className="required-asterisk">*</span>
  //               </label>
  //               <input
  //                 type="text"
  //                 className="form-control"
  //                 placeholder={t("meeting.newMeeting.placeholders.objective")}
  //                 value={momentName}
  //                 onChange={(e) => setMomentName(e.target.value)}
  //               />
  //             </div>

  //             <div className="mb-4 form d-flex flex-column form-group">
  //               <label className="form-label">
  //                 {t("meeting.formState.dateTime")}
  //                 <small style={{ color: "red", fontSize: "15px" }}>*</small>
  //               </label>
  //               <Flatpickr
  //                 data-enable-time
  //                 value={selectedDateTime}
  //                 onChange={handleChange}
  //                 options={{
  //                   locale: locale,
  //                   dateFormat: "d/m/Y, H:i",
  //                   time_24hr: true,
  //                   formatDate: (date) => formatDateWithCustomTime(date),
  //                 }}
  //               />
  //             </div>
  //           </div>
  //         </div>
  //       );
  //     default:
  //       return null;
  //   } 
    switch (step) {
      case 1:
        return (
          <div className="step-content">
            <div className="form-group">
              <Solution from="quick" />
            </div>
          </div>
        );
      case 2:
        return (
          <div className="step-content">
{/* ------------------Client */}

            <div className="form-group">
              <label className="form-label">
                {t("Client")}
                <span className="required-asterisk">*</span>
              </label>
              <OverlayTrigger
                placement="top"
                overlay={
                  <Tooltip id="client-tooltip">{t("clientTooltip")}</Tooltip>
                }
              >
                {meeting?.type === "Absence" ? (
                  // Readonly Select field for Absence type
                  <Select
                    classNamePrefix="select"
                    className="my-select destination-select-dropdown"
                    value={{
                      value: meeting?.destination?.clients?.id,
                      label:
                        meeting?.destination?.clients?.name ||
                        t("No client assigned"),
                      data: {
                        client_logo: meeting?.destination?.clients?.client_logo,
                        client_need_description:
                          meeting?.destination?.clients
                            ?.client_need_description,
                      },
                    }}
                    options={
                      meeting?.destination?.clients
                        ? [
                            {
                              value: meeting.destination.clients.id,
                              label: meeting.destination.clients.name,
                              data: {
                                client_logo:
                                  meeting.destination.clients.client_logo,
                                client_need_description:
                                  meeting.destination.clients
                                    .client_need_description,
                              },
                            },
                          ]
                        : []
                    }
                    isDisabled={true}
                    formatOptionLabel={(option) => (
                      <div className="option-with-logo">
                        {option.data?.client_logo && (
                          <img
                            src={
                              option.data.client_logo.startsWith("http")
                                ? option.data.client_logo
                                : `${Assets_URL}/${option.data.client_logo}`
                            }
                            alt={option.label}
                            className="client-logo"
                          />
                        )}
                        <span>{option.label}</span>
                      </div>
                    )}
                  />
                ) : (
                  <div>
                    <Creatable
                      className="my-select destination-select-dropdown"
                      classNamePrefix="select"
                      // isLoading={isClientsLoading}
                      options={usersArray}
                      onChange={handleClientSelect}
                      value={selectedClient}
                      placeholder={t("Select or create a client")}
                      formatOptionLabel={(option, { context }) => (
                        <div style={{ display: "flex", alignItems: "center" }}>
                          {/* Show client logo if available */}
                          {option.data?.client_logo && (
                            <img
                              src={
                                option.data.client_logo.startsWith("http")
                                  ? option.data.client_logo
                                  : `${Assets_URL}/${option.data.client_logo}`
                              }
                              alt={option.label}
                              style={{
                                width: "24px",
                                height: "24px",
                                borderRadius: "50%",
                                objectFit: "cover",
                                marginRight: "10px",
                              }}
                            />
                          )}
                          {/* Client name */}
                          <span>{option.label}</span>
                        </div>
                      )}
                      isClearable
                        styles={{
    control: (provided) => ({ ...provided, zIndex: 1 }),
    menuPortal: (provided) => ({ ...provided, zIndex: 9999 }) // Very high z-index
  }}
  menuPortalTarget={document.body}
  menuPosition="fixed" // This is crucial
                    />
                  </div>
                )}
              </OverlayTrigger>
            </div>
{/* ------------------Mission */}

             <div className="form-group">
              <label className="form-label">
                {t("Mission")}
                <span className="required-asterisk">*</span>
              </label>
              {meeting?.type === "Absence" ? (
                // Readonly Select field for Absence type
                <Select
                  classNamePrefix="select"
                  className="my-select destination-select-dropdown mb-3"
                  value={{
                    value: meeting?.destination?.id,
                    label:
                      meeting?.destination?.destination_name ||
                      t("No mission assigned"),
                    data: {
                      description:
                        meeting?.destination?.destination_description,
                    },
                  }}
                  options={
                    meeting?.destination
                      ? [
                          {
                            value: meeting.destination.id,
                            label: meeting.destination.destination_name,
                            data: {
                              description:
                                meeting.destination.destination_description,
                            },
                          },
                        ]
                      : []
                  }
                  isDisabled={true}
                />
              ) : (
               <Creatable
                              className="my-select"
                              classNamePrefix="select"
                              // isLoading={isMissionsLoading}
                              options={getFilteredMissions()} // Only show missions for selected client
                              onChange={handleMissionSelect}
                              value={selectedMission}
                              placeholder={t("Select a mission")}
                              isDisabled={!selectedClient}
                              isClearable
                              formatOptionLabel={formatMissionOption}
                                styles={{
    control: (provided) => ({ ...provided, zIndex: 1 }),
    menuPortal: (provided) => ({ ...provided, zIndex: 9999 }) // Very high z-index
  }}
  menuPortalTarget={document.body}
  menuPosition="fixed" // This is crucial
                            />
              )}
            </div>
             {selectedMission?.__isNew__ && (
                          <div className="form-group mt-3">
                            <label className="form-label">
                              {t("destination_type")}
                              <span className="required-asterisk">*</span>
                            </label>
                            <Select
                              className="my-select "
                              classNamePrefix="select"
                              styles={{
                                control: (provided, state) => ({
                                  ...provided,
                                  zIndex: 9, // Ensure dropdown is above other elements
                                }),
                              }}
                              options={missionTypeOptions}
                              value={missionTypeOptions.find(
                                (opt) => opt.value === destinationType
                              )}
                              onChange={(option) => setDestinationType(option.value)}
                              formatOptionLabel={(option) => (
                                <div style={{ display: "flex", alignItems: "center" }}>
                                  {getIcon(option)}
                                  <span>{option.label}</span>
                                </div>
                              )}
                              isClearable
                            />
                          </div>
                        )}

{/* ------------------Moment */}
           <div className="create-moment-modal">

             <div className="step-content">
                         <div className="form-group">
                <label className="form-label">
                  {t("Objective")} <span className="required-asterisk">*</span>
                </label>
                <input
                  type="text"
                  className="form-control"
                  placeholder={t("meeting.newMeeting.placeholders.objective")}
                  value={momentName}
                  onChange={(e) => setMomentName(e.target.value)}
                />
              </div>

              <div className="mb-4 form d-flex flex-column form-group">
                <label className="form-label">
                  {t("meeting.formState.dateTime")}
                  <small style={{ color: "red", fontSize: "15px" }}>*</small>
                </label>
                <Flatpickr
                  data-enable-time
                  value={selectedDateTime}
                  onChange={handleChange}
                  options={{
                    locale: locale,
                    dateFormat: "d/m/Y, H:i",
                    time_24hr: true,
                    formatDate: (date) => formatDateWithCustomTime(date),
                  }}
                />
              </div>

  </div>
  </div>
          </div>
        );
   
  //     case 4:
  //       return (
  //         <div className="create-moment-modal">
  //           <div className="step-content">
  //             <div className="d-flex flex-column gap-2 mb-4">
  //               {selectedClient && (
  //                 <div
  //                   className="selected-summary mb-3 p-3"
  //                   style={{ backgroundColor: "#f5f7fa", borderRadius: "8px" }}
  //                 >
  //                   <strong>{t("Selected Client")}:</strong>{" "}
  //                {selectedClient?.value && !selectedClient?.__isNew__
  //                 ? (() => {
  //                     // Search through all client groups for the matching client
  //                     for (const group of usersArray) {
  //                       const foundClient = group.options.find(
  //                         (opt) =>
  //                           Number(opt.value) === Number(selectedClient?.value)
  //                       );
  //                       if (foundClient) return foundClient.label;
  //                     }
  //                     return selectedClient?.label;
  //                   })()
  //                 : selectedClient?.label}
  //                 </div>
  //               )}

  //               {selectedMission && (
  //                 <div
  //                   className="selected-summary mb-3 p-3"
  //                   style={{ backgroundColor: "#f5f7fa", borderRadius: "8px" }}
  //                 >
  //                   <strong>{t("Selected Mission")}:</strong>{" "}
  // {selectedMission?.value && !selectedMission?.__isNew__
  //                 ? objectives.find(
  //                     (opt) =>
  //                       Number(opt.value) === Number(selectedMission?.value)
  //                   )?.label
  //                 : selectedMission?.label}
  //                 </div>
  //               )}
  //             </div>

             
  //           </div>
  //         </div>
  //       );
      default:
        return null;
    }





// switch (step) {
//   case 1:
//     return (
//       <div className="step-content">
//         <div className="form-group">
//           <Solution from="quick" />
//         </div>
//       </div>
//     );
//   case 2:
//     return (
//       <div className="step-content">
//         <div className="form-group">
//           <label className="form-label">
//             {t("Client")}
//             <span className="required-asterisk">*</span>
//           </label>
//           <OverlayTrigger
//             placement="top"
//             overlay={
//               <Tooltip id="client-tooltip">{t("clientTooltip")}</Tooltip>
//             }
//           >
//             {meeting?.type === "Absence" ? (
//               // Readonly Select field for Absence type
//               <Select
//                 classNamePrefix="select"
//                 className="my-select destination-select-dropdown"
//                 value={{
//                   value: meeting?.destination?.clients?.id,
//                   label:
//                     meeting?.destination?.clients?.name ||
//                     t("No client assigned"),
//                   data: {
//                     client_logo: meeting?.destination?.clients?.client_logo,
//                     client_need_description:
//                       meeting?.destination?.clients
//                         ?.client_need_description,
//                   },
//                 }}
//                 options={
//                   meeting?.destination?.clients
//                     ? [
//                         {
//                           value: meeting.destination.clients.id,
//                           label: meeting.destination.clients.name,
//                           data: {
//                             client_logo:
//                               meeting.destination.clients.client_logo,
//                             client_need_description:
//                               meeting.destination.clients
//                                 .client_need_description,
//                           },
//                         },
//                       ]
//                     : []
//                 }
//                 isDisabled={true}
//                 formatOptionLabel={(option) => (
//                   <div className="option-with-logo">
//                     {option.data?.client_logo && (
//                       <img
//                         src={
//                           option.data.client_logo.startsWith("http")
//                             ? option.data.client_logo
//                             : `${Assets_URL}/${option.data.client_logo}`
//                         }
//                         alt={option.label}
//                         className="client-logo"
//                       />
//                     )}
//                     <span>{option.label}</span>
//                   </div>
//                 )}
//               />
//             ) : (
//               <div>
//                 <Creatable
//                   className="my-select destination-select-dropdown"
//                   classNamePrefix="select"
//                   options={usersArray}
//                   onChange={(selectedOption) => {
//                     handleClientSelect(selectedOption);
                    
//                     // Set default mission based on user profile and selected client
//                     if (selectedOption) {
//                       const clientName = selectedOption.label;
//                       let defaultMissionLabel = '';
//                       let defaultMissionType = '';
//                       let defaultMomentLabel = '';
                      
//                       // Determine defaults based on user profile
//                       switch(userProfile) { // Assuming userProfile is available in your context
//                         case 'Project Manager / Product Owner':
//                         case 'Manager / Team Leader':
//                         case 'Developer / Operational Contributor':
//                           defaultMissionLabel = `Projet ${clientName}`;
//                           defaultMissionType = 'project';
//                           defaultMomentLabel = `REUNION ${clientName}`;
//                           break;
//                         case 'Customer Relations Officer / Sales Representative':
//                           defaultMissionLabel = `Opportunité client ${clientName}`;
//                           defaultMissionType = 'opportunity';
//                           defaultMomentLabel = `rdv client ${clientName}`;
//                           break;
//                         case 'Trainer / Coach':
//                         case 'Consultant / Freelance':
//                         case 'Other / Explorer':
//                         default:
//                           defaultMissionLabel = clientName;
//                           defaultMissionType = 'other';
//                           defaultMomentLabel = clientName;
//                       }
                      
//                       // Set default mission
//                       const defaultMission = {
//                         __isNew__: true,
//                         label: defaultMissionLabel,
//                         value: defaultMissionLabel,
//                       };
//                       setSelectedMission(defaultMission);
                      
//                       // Set default moment name
//                       setMomentName(defaultMomentLabel);
                      
//                       // Set default destination type
//                       setDestinationType(defaultMissionType);
//                     }
//                   }}
//                   value={selectedClient}
//                   placeholder={t("Select or create a client")}
//                   formatOptionLabel={(option, { context }) => (
//                     <div style={{ display: "flex", alignItems: "center" }}>
//                       {option.data?.client_logo && (
//                         <img
//                           src={
//                             option.data.client_logo.startsWith("http")
//                               ? option.data.client_logo
//                               : `${Assets_URL}/${option.data.client_logo}`
//                           }
//                           alt={option.label}
//                           style={{
//                             width: "24px",
//                             height: "24px",
//                             borderRadius: "50%",
//                             objectFit: "cover",
//                             marginRight: "10px",
//                           }}
//                         />
//                       )}
//                       <span>{option.label}</span>
//                     </div>
//                   )}
//                   isClearable
//                 />
//               </div>
//             )}
//           </OverlayTrigger>
//         </div>
        
//         {/* Mission field - now appears immediately after client selection */}
//         {selectedClient && (
//           <div className="form-group mt-3">
//             <label className="form-label">
//               {t("Mission")}
//               <span className="required-asterisk">*</span>
//             </label>
//             {meeting?.type === "Absence" ? (
//               <Select
//                 classNamePrefix="select"
//                 className="my-select destination-select-dropdown mb-3"
//                 value={{
//                   value: meeting?.destination?.id,
//                   label:
//                     meeting?.destination?.destination_name ||
//                     t("No mission assigned"),
//                   data: {
//                     description:
//                       meeting?.destination?.destination_description,
//                   },
//                 }}
//                 options={
//                   meeting?.destination
//                     ? [
//                         {
//                           value: meeting.destination.id,
//                           label: meeting.destination.destination_name,
//                           data: {
//                             description:
//                               meeting.destination.destination_description,
//                           },
//                         },
//                       ]
//                     : []
//                 }
//                 isDisabled={true}
//               />
//             ) : (
//              <Creatable
//                 className="my-select destination-select-dropdown"
//                 classNamePrefix="select"
//                 options={getFilteredMissions()}
//                 onChange={handleMissionSelect}
//                 value={selectedMission}
//                 placeholder={t("Select a mission")}
//                 isClearable
//                 formatOptionLabel={formatMissionOption}
//               />
//             )}
//           </div>
//         )}
        
//         {/* Moment field - appears after client selection */}
//         {selectedClient && (
//           <div className="form-group mt-3">
//             <label className="form-label">
//               {t("Objective")} <span className="required-asterisk">*</span>
//             </label>
//             <input
//               type="text"
//               className="form-control"
//               placeholder={t("meeting.newMeeting.placeholders.objective")}
//               value={momentName}
//               onChange={(e) => setMomentName(e.target.value)}
//             />
//           </div>
//         )}
//       </div>
//     );
//   case 3:
//     return (
//       <div className="step-content">
//         {selectedClient && (
//           <div
//             className="selected-summary mb-3 p-3"
//             style={{ backgroundColor: "#f5f7fa", borderRadius: "8px" }}
//           >
//             <strong>{t("Selected Client")}:</strong>{" "}
//            {selectedClient?.value && !selectedClient?.__isNew__
//               ? (() => {
//                   // Search through all client groups for the matching client
//                   for (const group of usersArray) {
//                     const foundClient = group.options.find(
//                       (opt) =>
//                         Number(opt.value) === Number(selectedClient?.value)
//                     );
//                     if (foundClient) return foundClient.label;
//                   }
//                   return selectedClient?.label;
//                 })()
//               : selectedClient?.label}
//           </div>
//         )}

//         {selectedMission && (
//           <div
//             className="selected-summary mb-3 p-3"
//             style={{ backgroundColor: "#f5f7fa", borderRadius: "8px" }}
//           >
//             <strong>{t("Selected Mission")}:</strong>{" "}
//             {selectedMission?.value && !selectedMission?.__isNew__
//               ? objectives.find(
//                   (opt) =>
//                     Number(opt.value) === Number(selectedMission?.value)
//                 )?.label
//               : selectedMission?.label}
//           </div>
//         )}
//       </div>
//     );
//   case 4:
//     return (
//       <div className="create-moment-modal">
//         <div className="step-content">
//           <div className="d-flex flex-column gap-2 mb-4">
//             {selectedClient && (
//               <div
//                 className="selected-summary mb-3 p-3"
//                 style={{ backgroundColor: "#f5f7fa", borderRadius: "8px" }}
//               >
//                 <strong>{t("Selected Client")}:</strong>{" "}
//                 {selectedClient?.value && !selectedClient?.__isNew__
//                   ? (() => {
//                       for (const group of usersArray) {
//                         const foundClient = group.options.find(
//                           (opt) =>
//                             Number(opt.value) === Number(selectedClient?.value)
//                         );
//                         if (foundClient) return foundClient.label;
//                       }
//                       return selectedClient?.label;
//                     })()
//                   : selectedClient?.label}
//               </div>
//             )}

//             {selectedMission && (
//               <div
//                 className="selected-summary mb-3 p-3"
//                 style={{ backgroundColor: "#f5f7fa", borderRadius: "8px" }}
//               >
//                 <strong>{t("Selected Mission")}:</strong>{" "}
//                 {selectedMission?.value && !selectedMission?.__isNew__
//                   ? objectives.find(
//                       (opt) =>
//                         Number(opt.value) === Number(selectedMission?.value)
//                     )?.label
//                   : selectedMission?.label}
//               </div>
//             )}
//           </div>

//           <div className="form-group">
//             <label className="form-label">
//               {t("Objective")} <span className="required-asterisk">*</span>
//             </label>
//             <input
//               type="text"
//               className="form-control"
//               placeholder={t("meeting.newMeeting.placeholders.objective")}
//               value={momentName}
//               onChange={(e) => setMomentName(e.target.value)}
//             />
//           </div>

//           <div className="mb-4 form d-flex flex-column form-group">
//             <label className="form-label">
//               {t("meeting.formState.dateTime")}
//               <small style={{ color: "red", fontSize: "15px" }}>*</small>
//             </label>
//             <Flatpickr
//               data-enable-time
//               value={selectedDateTime}
//               onChange={handleChange}
//               options={{
//                 locale: locale,
//                 dateFormat: "d/m/Y, H:i",
//                 time_24hr: true,
//                 formatDate: (date) => formatDateWithCustomTime(date),
//               }}
//             />
//           </div>
//         </div>
//       </div>
//     );
//   default:
//     return null;
// }
  };

  return (
    <>
      {show && (
        <div className="quick-moment-form">
          <div className="modal-overlay-1">
            <div className="new-meeting-modal-1">
              <div className="modal-nav">
                <h4>{t("addQuickMomentbtninmission")}</h4>
                <button className="cross-btn" onClick={handleCancel}>
                  <RxCross2 size={18} />
                </button>
              </div>

              <div className="modal-body">
                <div className="progress-container-1">
                  <div className="progress-track">
                    <div
                      className="progress-fill"
                        style={{
        width: openedFrom === "mission" 
          ? `${((step - 1) / 1) * 100}%`  // For mission flow (2 steps: 0% to 100%)
          : `${((step - 1) / 3) * 100}%`  // For normal flow (4 steps: 0% to 100%)
      }}
                    ></div>
                  </div>
                  <div className="progress-steps">
                    {openedFrom === "mission" ? (
                      <>
                        <div
                          className={`progress-step ${
                            step >= 1 ? "active" : ""
                          }`}
                        >
                          <div className="step-number">1</div>
                          <div className="step-label">{t("Solution")}</div>
                        </div>
                        <div
                          className={`progress-step ${
                            step >= 2 ? "active" : ""
                          }`}
                        >
                          <div className="step-number">2</div>
                          <div className="step-label">{t("Moment")}</div>
                        </div>
                      </>
                    ) : (
                      <>
                        <div
                          className={`progress-step ${
                            step >= 1 ? "active" : ""
                          }`}
                        >
                          <div className="step-number">1</div>
                          <div className="step-label">{t("Solution")}</div>
                        </div>
                        <div
                          className={`progress-step ${
                            step >= 2 ? "active" : ""
                          }`}
                        >
                          <div className="step-number">2</div>
                          <div className="step-label">{t("Moment")}</div>
                        </div>
                        {/* <div
                          className={`progress-step ${
                            step >= 3 ? "active" : ""
                          }`}
                        >
                          <div className="step-number">3</div>
                          <div className="step-label">{t("Mission")}</div>
                        </div>
                        <div
                          className={`progress-step ${
                            step >= 4 ? "active" : ""
                          }`}
                        >
                          <div className="step-number">4</div>
                          <div className="step-label">{t("Moment")}</div>
                        </div> */}
                      </>
                    )}
                  </div>
                </div>

                {renderStepContent()}
              </div>

              <div className="modal-footer-fixed">
                {/* {step > 1 && openedFrom !== "mission" && (
                  <button
                    className="btn btn-outline-secondary"
                    onClick={handleBack}
                  >
                    {t("Previous")}
                  </button>
                )} */}
                {openedFrom === "mission" ? (
                  <>
                    {step === 1 ? (
                      <button
                        className="btn"
                        style={{
                          fontFamily: "Inter",
                          fontSize: "14px",
                          fontWeight: 600,
                          lineHeight: "24px",
                          textAlign: "left",
                          color: " #FFFFFF",
                          background: "#2C48AE",
                          border: 0,
                          outine: 0,
                          padding: "10px 16px",
                          borderRadius: "9px",
                        }}
                        onClick={handleCreate}
                        // disabled={
                        //   (step === 1 && !momentType) ||
                        //   (step === 2 && !client && !destinationType)
                        // }
                      >
                        {t("meeting.formState.Save and Continue")}
                      </button>
                    ) : (
                      <button
                        className="btn"
                        style={{
                          fontFamily: "Inter",
                          fontSize: "14px",
                          fontWeight: 600,
                          lineHeight: "24px",
                          textAlign: "left",
                          color: " #FFFFFF",
                          background: "#2C48AE",
                          border: 0,
                          outine: 0,
                          padding: "10px 16px",
                          borderRadius: "9px",
                        }}
                        onClick={handleFinalSubmit}
                        disabled={!momentName}
                      >
                        {t("meeting.formState.Save and Continue")}
                      </button>
                    )}
                  </>
                ) : (
                  <>
                    {step < 2 ? (
                      <button
                        className="btn"
                        style={{
                          fontFamily: "Inter",
                          fontSize: "14px",
                          fontWeight: 600,
                          lineHeight: "24px",
                          textAlign: "left",
                          color: " #FFFFFF",
                          background: "#2C48AE",
                          border: 0,
                          outine: 0,
                          padding: "10px 16px",
                          borderRadius: "9px",
                        }}
                        onClick={handleCreate}
                        // disabled={
                        //   (step === 1 && !momentType) ||
                        //   (step === 2 && !client && !destinationType)
                        // }
                      >
                        {t("meeting.formState.Save and Continue")}
                      </button>
                    ) : (
                      <button
                        className="btn"
                        style={{
                          fontFamily: "Inter",
                          fontSize: "14px",
                          fontWeight: 600,
                          lineHeight: "24px",
                          textAlign: "left",
                          color: " #FFFFFF",
                          background: "#2C48AE",
                          border: 0,
                          outine: 0,
                          padding: "10px 16px",
                          borderRadius: "9px",
                        }}
                        onClick={handleFinalSubmit}
                        disabled={!momentName}
                      >
                        {t("meeting.formState.Save and Continue")}
                      </button>
                    )}
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      )}

      <Modal
        show={showConfirmation}
        onHide={handleCloseConfirmation}
        centered
        className="confirmation-modal"
      >
        <Modal.Header closeButton>
          <Modal.Title>{t("areYouSure")}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>{t("unsavedChangesWarning")}</p>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="outline-secondary" onClick={handleCloseConfirmation}>
            {t("Cancel")}
          </Button>
          <Button
            variant="danger"
            className="px-4 py-2 confirmation-delete"
            onClick={onClose}
          >
            {t("Yes")}
          </Button>
        </Modal.Footer>
      </Modal>

      {showStepsModal && meeting && (
        <div className="new-meeting-modal">
          <div className="tektimetabs">
            <QuickStepChart
              meetingId={meeting?.id}
              id={id}
              show={showStepsModal}
              setId={setId}
              closeModal={() => setShowStepsModal(false)}
              meeting={meeting}
              setMeeting={setMeeting}
              isDrop={isDrop}
              setIsDrop={setIsDrop}
              closeMeeting={onClose}
            />
          </div>
        </div>
      )}
    </>
  );
};

export default QuickMomentForm;
